import { PurchaseOrder } from 'domains/orderDomain';
import { purchaseOrderPrice } from 'utils/jobConfig';

export const useOrderPrice = (orderItems: Partial<PurchaseOrder>) => {
  return purchaseOrderPrice(orderItems);
};
